import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { OutlinedInput } from '@mui/material';

// project imports
import { ThemeMode } from '../../../../config';
import { useDispatch, useSelector } from 'react-redux';
import { editColumn } from '../../../../store/reducer/kanban';

const EditColumn = ({ column }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const { columns, selected_tenant } = useSelector((state) => state.kanban);

  const handleColumnRename = (event) => {
    dispatch(
      editColumn(
        {
          id: column.id,
          title: event.target.value,
          itemIds: column.itemIds
        },
        columns,
          selected_tenant
      )
    );
  };

  return (
    <OutlinedInput
      fullWidth
      value={column?.title}
      onChange={handleColumnRename}
      sx={{
        mb: 1.5,
        fontWeight: 500,
        '& input:focus': {
          bgcolor: "fafafa"
        },
        '& input:hover': {
          bgcolor: 'fafafa'
        },
        '& input:hover + fieldset': {
          display: 'block'
        },
        '&, & input': { bgcolor: 'transparent' },
        '& fieldset': { display: 'none' },
        '& input:focus + fieldset': { display: 'block' }
      }}
    />
  );
};

EditColumn.propTypes = {
  column: PropTypes.object
};

export default EditColumn;